import DocumentSelect from './DocumentSelect'
export default DocumentSelect
